import { useRef, useEffect } from 'react';

var useTimeout = function (fnc, time) {
    var timer = useRef();
    useEffect(function () {
        return function () { return clearTimeout(timer.current); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        set: function () {
            timer.current = window.setTimeout(fnc, time);
        },
        clear: function () {
            clearTimeout(timer.current);
        },
    };
};

export { useTimeout as default };
